// libraries
import React from 'react'

// components
import Image from '/react4xp/components/Image'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

interface QuoteFullWidthProps {
    img?: {
		src: string
		srcSmall: string
		srcMedium: string
		srcLarge: string
		alt?: string
	}
    text: string
    name: string
    position?: string
}

export default function QuoteFullWidth({
    img,
    text,
    name,
    position
}: QuoteFullWidthProps) {
    return (
        <div className='quote-full-width'>

            <div className='quote-full-width__bg cover'>
				{img?.src && (
					<Image
						srcSmall={[`${img.srcSmall}`, 574]} // 550x750
						srcMedium={[`${img.srcMedium}`, 991]} // 1000x1100 
						srcLarge={[`${img.srcLarge}`, 1439]} // 1400x900
						src={img.src} // 1900x1100
						alt={img.alt}
						className='cover'
					/>
				)}
			</div>

            <div className='grid-container'>
                <div className='grid-row'>
                    <div className='c-lg-6 c-xxl-5 quote-full-width__wrapper'>
                        <div className='quote-full-width__box'>

                            {isNonWhitespaceString(text) && (
                                <div
                                    className='quote-full-width__quote'
                                    dangerouslySetInnerHTML={{ __html: text }}
                                    suppressHydrationWarning
                                />
                            )}

                            {isNonWhitespaceString(name) && (
                                <p className='quote-full-width__name'>
                                    {name}
                                </p>
                            )}

                            {isNonWhitespaceString(position) && (
                                <p className='quote-full-width__position'>
                                    {position}
                                </p>
                            )}

                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}